/* eslint-disable react/prop-types */
// HandCrushed.jsx
import React from 'react'

const HandCrushedDefault = ({ style }) => <HandCrushed style={style} />

export default HandCrushedDefault

const HandCrushed = ({ style }) => {
  const svgStyle = { fill: '#fff', ...style, stroke: 'none' }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 100 100'
    >
      <path d='M66.1,57.4l6.8-4l8.3,10.3c0,0,1.4,3.9-2.1,3.4c-3.5-0.4-6.2-2.5-8.4-4.9C68.4,59.9,66.1,57.4,66.1,57.4z' />
      <path d='M76,51.1l3.7,3.8l11.7,3.4c0,0,3.8,1.3,6-0.4c2.3-1.7,3.2-4.5,0-5.2c-3.2-0.7-15.9-5.2-15.9-5.2L76,50.5' />
      <polygon points='56.7,55 51.8,55 49,61.8 49,100 60,100 60,61.8' />
      <polygon points='51.8,46 56.7,46 60,39.2 60,0 49,0 49,39.2' />
      <path d='M89,30c0,0-15.1,8.8-20.1,11.4c-5,2.5-7.6,3.8-7.6,3.8L59.2,48H50l-2.6-2.4c0,0-17.8-5.3-21.5-8
            c-3.2-2.4-5.5-0.5-5.5-0.5L0,43.1v26.4l22.1-14.3l10.3,10.1c0,0,0.2,13.6,0.2,16.1c0,2.5-0.7,9.4,4.3,10.4
            c3.5,0.7,5.6-5.2,5.9-7.7c0.7-6.3,1.6-21.2,1.6-21.2l6.8-9.8h7.1l3.2,4.3c0,0,21.1-13.5,24.9-16c3.8-2.5,5-3.7,6.3-8.8
            C94,27.5,89,30,89,30z'
      />
    </svg>
  )
}
